<div class="container">
  <div class="row">
    <line class="col-lg-6 col-md-12 charts" *ngIf="lineChartData" [chartData]="lineChartData"></line>
    <advanced-pie class="col-lg-6 col-md-12 charts" *ngIf="advancedPieData" [chartData]="advancedPieData"></advanced-pie>
    <profit class="col-lg-6 col-md-12 charts" *ngIf="profitData" [profits]="profitData"></profit>
  </div>
</div>
